// pages/HomePage.js
import React, { useRef } from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Features from '../components/Features';
import VideoShowcase from '../components/VideoShowcase';
import DemoVideos from '../components/DemoVideos';
import Comparison from '../components/Comparison_Enhanced';
import Quote from '../components/Quote';
import UseCases from '../components/UseCases';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import CTA from '../components/CTA_Enhanced';
import TeamEmpowerment from '../components/TeamEmpowerment';
import LatestBlog from '../components/LatestBlog';
import {
  organizationSchema,
  webSiteSchema,
  softwareApplicationSchema,
  howToSchema,
} from '../data/structuredData';

const homeJsonLd = [
  organizationSchema,
  webSiteSchema,
  softwareApplicationSchema,
  howToSchema,
];

function HomePage() {
  // Create refs for each section that needs parallax
  const comparisonRef = useRef(null);
  const quoteRef = useRef(null);
  const pricingRef = useRef(null);
  const useCasesRef = useRef(null);
  const howItWorksRef = useRef(null);
  const ctaRef = useRef(null);


  return (
    <>
      <SEO
        title="Qate AI - GenAI Quality Assurance | AI Testing for Web, Desktop & API"
        description="AI testing platform that clicks, types, and navigates your app like a real user. Conversational test creation, self-healing tests, automated bug fixing for web, Windows desktop & API."
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <Features />
      <VideoShowcase />
      <div ref={comparisonRef}>
        <Comparison />
      </div>
      <DemoVideos />
      <TeamEmpowerment />
      <div ref={quoteRef}>
        <Quote />
      </div>
      <div ref={pricingRef}>
        <Pricing />
      </div>
      <div ref={useCasesRef}>
        <UseCases />
      </div>
      <div ref={howItWorksRef}>
        <HowItWorks />
      </div>
      <LatestBlog />
      <div ref={ctaRef}>
        <CTA />
      </div>
    </>
  );
}

export default HomePage;
